import setDate from './utils/set-date';
import setSelectYear from './utils/set-select-year';
import setAgreements from './utils/set-agreements';
import removeFields from './utils/remove-fields';
import clearFormFields from './utils/clear-form';
import powermailDatepicker from '../powermail_datepicker';

export default class Form {
    constructor(formEl, button, formValidator) {
        // El
        this.form = formEl;

        // Dependency injection
        this.formValidator = formValidator;
        this.disableValidation = Boolean(this.form.querySelector('[formnovalidate]'));
        this.submitBtn = button;

        // Events
        this.$handleFormSubmit = this._handleFormSubmit.bind(this);
        this.$handleFormChange = this._handleFormChange.bind(this);
        this.$handleReset = this.clearForm.bind(this);
        this.$handleMaxDate = this._handleMaxDate.bind(this);

        this.init();
    }

    /**
     * Start do some logic
     */
    init() {
        this._getDOMElements();
        this._initEventListeners();

        powermailDatepicker('load', this.form);
        powermailDatepicker('change', this.form);
    }

    /**
     * Remove event listeners from form
     */
    destroy() {
        this._removeEventListeners();
        this.formValidator.destroy();
    }

    update() {
        this.destroy();
        this.init();
    }

    /**
     * Clear form
     */
    clearForm() {
        this.submitBtn.enable();

        clearFormFields(this.form);
    }

    /**
     * Check if form is valid
     */
    get isValid() {
        const isParsleyValid = !this.form.querySelector('.parsley-error');

        let isValid = isParsleyValid;

        if (this.formValidator && isValid) {
            isValid = this.formValidator.isValid;
            console.log(isValid, this.formValidator);
        }

        return isValid;
    }

    /**
     * Get DOM elements and add it to class instance
     */
    _getDOMElements() {
        this.dateSelect = this.form.querySelector('#tx_news_year');
        this.datepicker = this.form.querySelector('#input-date');
        this.agreement = this.form.querySelector('.js-agreement');
        this.agreementHiddenInput = this.form.querySelector('#agreement');
        this.dateFixedField = this.form.querySelector('.js-fixed-date') || document.querySelector('.js-fixed-date');
    }

    /**
     * Add listeners to form
     */
    _initEventListeners() {
        setTimeout(() => {
            this.form.addEventListener('submit', this.$handleFormSubmit);
            this.form.addEventListener('reset', this.$handleReset);
            if (this.dateFixedField) {
                this.dateFixedField.addEventListener('input', this.$handleMaxDate);
            }
        }, 200);
    }

    /**
     * Remove listeners from form
     */
    _removeEventListeners() {
        this.form.removeEventListener('submit', this.$handleFormSubmit);
        this.form.removeEventListener('reset', this.$handleReset);
        this._removeInputEventListener();
    }

    /**
     * Add change listener to form
     */
    _addInputEventListener() {
        this.form.addEventListener('input', this.$handleFormChange);
    }

    /**
     * Remove change listener from form
     */
    _removeInputEventListener() {
        this.form.removeEventListener('input', this.$handleFormChange);
    }

    /**
     * Hande input change inside the form
     */
    _handleFormChange() {
        this.submitBtn.enable();
        this._removeInputEventListener();
    }

    /**
     * Remove input listener from input type="date"
     */
    _handleMaxDate(e) {
        const dateField = e.target;
        const maxDate = dateField.getAttribute('max');
        const currDate = dateField.value;

        if (maxDate && currDate) {
            dateField.value = new Date(currDate) > new Date(maxDate) ? maxDate : currDate;
        }
    }

    /**
     * Handle form submit
     * Set dates, years and agreements
     * @param {Event} e - event
     */
    _handleFormSubmit(e) {
        this.submitBtn.disable();
        this._addInputEventListener();

        if (!this.disableValidation && !this.isValid) {
            console.warn('Prevent form submit');
            e.preventDefault();
            return;
        }


        // TODO: Refactor this component
        // TODO: Move it to validators
        if (!this.disableValidation) {
            powermailDatepicker('submit', this.form, e);
        }

        if (this.datepicker) {
            setDate(this.datepicker);
        }

        if (this.dateSelect) {
            setSelectYear(this.dateSelect);
        }

        if (this.agreement) {
            setAgreements(this.agreement, this.agreementHiddenInput);
        }

        // Remove fields according to constants (contants.js)
        removeFields(this.form);
    }
}
